import React from 'react';
import { LobsterTrapPriceSlider } from '../common/SliderControls/SliderControls';
import type { RegistryComponentProps } from '../../pages/registry/componentRegistry';
import { getRegistryData } from '../../pages/registry/componentRegistry';
import { useFormContextOptional } from '../../contexts/FormContext';

const SLUG = 'trap-price';
const SLUG_DB = 'trap-price-db';

const DEFAULT_TRAP_PRICE = 180;

interface TrapPriceData {
  updatingParams?: boolean;
  fuelPriceUpdatingParams?: boolean;
  lobsterDisabled?: boolean;
}

export default function TrapPrice(props: RegistryComponentProps): React.ReactElement {
  const formContext = useFormContextOptional();
  const data = getRegistryData<TrapPriceData>(props);

  const formValue = formContext?.values?.[SLUG] as number | undefined;
  const formDbValue = formContext?.values?.[SLUG_DB] as number | undefined;
  const trapPrice = formValue ?? DEFAULT_TRAP_PRICE;
  const dbTrapPrice = formDbValue ?? trapPrice;
  const updatingParams =
    data.updatingParams ?? data.fuelPriceUpdatingParams ?? data.lobsterDisabled ?? false;

  const handleTrapPriceChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = parseFloat(e.target.value);
      formContext?.setValue(SLUG, value);
    },
    [formContext]
  );

  return (
    <LobsterTrapPriceSlider
      trapPrice={trapPrice}
      dbTrapPrice={dbTrapPrice}
      handleTrapPriceChange={handleTrapPriceChange}
      updatingParams={updatingParams}
    />
  );
}
